import { render, staticRenderFns } from "./AllOrdersView.vue?vue&type=template&id=734bea49&scoped=true"
import script from "./AllOrdersView.vue?vue&type=script&lang=js"
export * from "./AllOrdersView.vue?vue&type=script&lang=js"
import style0 from "./AllOrdersView.vue?vue&type=style&index=0&id=734bea49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734bea49",
  null
  
)

export default component.exports